module.exports = __webpack_public_path__ + "img/96.ed1303e6.jpg";